import axios from 'axios'

const apiPublic = {
	install (Vue, options) {
		Vue.prototype.$apiPublic = {
			get_legacy_contracts (url, contracts) {
				return new Promise((resolve, reject) => {
					if (!url) url = window.appConfig._$6vltrx._$377jy0 + 'legacy_contracts/'
					if (!contracts) contracts = []
					let options = {
						baseURL: url,
						method: 'get',
						headers: {
							Authorization: window.appConfig._$6vltrx._$4k7y9y,
							'Content-Type': 'application/json'
						}
					}
					axios(options)
						.then(response => {
							contracts.push(...response.data.results)
							if (response.data.next) {
								resolve(this.get_legacy_contracts(response.data.next, contracts))
							} else {
								resolve(contracts)
							}
						})
						.catch(error => {
							reject(error)
						})
				})
			},
			get_legacy_contract_assets (legacy_contract_id, url, asset_ids) {
				return new Promise((resolve, reject) => {
					if (!url) url = window.appConfig._$6vltrx._$377jy0 + 'materials/?category=legacy&fields=mat_id&legacy_contract_id=' + legacy_contract_id
					if (!asset_ids) asset_ids = []
					let options = {
						baseURL: url,
						method: 'get',
						headers: {
							Authorization: window.appConfig._$6vltrx._$4k7y9y,
							'Content-Type': 'application/json'
						}
					}
					axios(options)
						.then(response => {
							if (response.data.length) {
								asset_ids.push(...response.data.map(item => item.mat_id))
								let nextUrl = new URL(url)
								let currentPage = parseInt(nextUrl.searchParams.get('page')) || 1
								currentPage++
								nextUrl.searchParams.set('page', currentPage)
								resolve(this.get_legacy_contract_assets(legacy_contract_id, nextUrl, asset_ids))
							} else {
								resolve(asset_ids)
							}
						})
						.catch(error => {
							reject(error)
						})
				})
			},
			materials (ref) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: window.appConfig._$6vltrx._$377jy0 + 'materials/',
						method: 'get',
						params: {
							ref_materiel: ref,
							per_page: 100
						},
						headers: {
							Authorization: window.appConfig._$6vltrx._$4k7y9y,
							'Content-Type': 'application/json'
						}
					}
					axios(options)
						.then(response => {
							resolve(response.data)
						})
						.catch(error => {
							reject(error)
						})
				})
			},
			material (mat_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: window.appConfig._$6vltrx._$377jy0 + 'materials/' + mat_id,
						method: 'get',
						headers: {
							Authorization: window.appConfig._$6vltrx._$4k7y9y,
							'Content-Type': 'application/json'
						}
					}
					axios(options)
						.then(response => {
							resolve(response.data)
						})
						.catch(error => {
							reject(error)
						})
				})
			},
			material_search (parameters, with_detail = false) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: window.appConfig._$6vltrx._$377jy0 + 'materials/',
						method: 'get',
						headers: {
							Authorization: window.appConfig._$6vltrx._$4k7y9y,
							'Content-Type': 'application/json'
						},
						params: parameters
					}
					axios(options)
						.then(response => {
							if (with_detail) {
								let materialDetailsPromises = response.data.map(material => {
									return this.material(material.mat_id)
								})
								Promise.all(materialDetailsPromises)
									.then(materialDetails => {
										resolve(materialDetails)
									})
									.catch(error => {
										reject(error)
									})
							} else {
								resolve(response.data)
							}
						})
						.catch(error => {
							reject(error)
						})
				})
			},
			contract_search (t_aux) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: window.appConfig._$6vltrx._$377jy0 + 'contracts/?search=' + t_aux,
						method: 'get',
						headers: {
							Authorization: window.appConfig._$6vltrx._$4k7y9y,
							'Content-Type': 'application/json'
						}
					}
					axios(options)
						.then(response => {
							resolve(response.data)
						})
						.catch(error => {
							reject(error)
						})
				})
			}
		}
	}
}

export default apiPublic



// WEBPACK FOOTER //
// ./src/api/public_api.js